import * as ng from 'angular';

class CaptchaController implements ng.IComponentController {
   sitekey:string;
   language?:string;
   onSuccess:(args: { token: string }) => void;

   private elementId:string;

   static $inject = ['$element', '$timeout'];
   constructor(
      private $element:ng.IAugmentedJQuery,
      private $timeout:ng.ITimeoutService
   ) {}

   $onInit() {
      this.elementId = 'turnstile-' + Math.random().toString(36).substring(2);
   }

   $postLink() {
      this.$timeout(() => {
         if (window['turnstile']) {
            window['turnstile'].render(`#${this.elementId}`, {
               sitekey: this.sitekey,
               language: this.language || 'en',
               callback: (token:string) => {
                  if (this.onSuccess) {
                     this.onSuccess({ token });
                  }
               }
            });
         } else {
            console.error('Cloudflare Turnstile script is not loaded.');
         }
      });
   }
}

ng.module('selfReg').component('captcha', {
   controller: CaptchaController,
   template: `<div class="form-group" id="{{$ctrl.elementId}}"></div>`,
   bindings: {
      sitekey: '@',
      language: '@',
      onSuccess: '&',
      onError: '&'
   }
});
